import React from "react";
import { useDispatch } from "react-redux";
import { filterBy } from "../redux/filter/actions";

export default function Post({ data }) {
  const dispatch = useDispatch();
  const {
    tag = "",
    title = "",
    thumbnail = "",
    author = "",
    authorAvatar = "",
    postDate = "",
    readingDuration = "",
  } = data;
  return (
    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={thumbnail} alt={title} />
      </div>

      <div className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-indigo-600">
            <span
              onClick={() => dispatch(filterBy("tag", tag))}
              className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"
            >
              {tag}
            </span>
          </p>
          <a href="/" className="block mt-1">
            <p className="text-xl font-semibold text-gray-900">{title}</p>
          </a>
        </div>
        <div className="mt-6 flex items-center">
          <div className="flex-shrink-0">
            <img
              onClick={() => dispatch(filterBy("author", author))}
              className="h-10 w-10 rounded-full"
              src={authorAvatar}
              alt={author}
            />
          </div>
          <div className="ml-3">
            <p
              onClick={() => dispatch(filterBy("author", author))}
              className="text-sm font-medium text-gray-900 hover:underline"
            >
              {author}
            </p>
            <div className="flex space-x-1 text-sm text-gray-500">
              <time dateTime="2020-03-16">{postDate}</time>
              <span aria-hidden="true">&middot;</span>
              <span> {readingDuration} min read</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
